// extracted by mini-css-extract-plugin
export default {"root":"DlToEBlwJsCtLmWWrv_f","title":"H4YX2IGUmuuXwJvZRA1w","link":"RQniHMtSu3zOkNTTnsRs"};